/**
 * Labstep
 *
 * @module components/FilterPost/Report/Boolean
 * @desc Filter to toggle between deleted items
 */

import { FilterPostReportBooleanForm } from 'labstep-web/components/FilterPost/Report/Boolean/Form';
import { ICONS } from 'labstep-web/constants/icons';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { ModalDefaultContainer as Modal } from 'labstep-web/core/Modal/Default';
import type React from 'react';
import type { FilterPostReportBooleanProps } from './types';

export const FilterPostReportBoolean: React.FC<
  FilterPostReportBooleanProps
> = ({
  label,
  path,
  field,
  addPostFilter,
  defaultValues,
  ...rest
}) => (
  <Modal
    header={`Filter by ${label}`}
    viewComponent={({ toggleModal }): React.ReactNode => (
      <ActionComponent
        onClick={toggleModal}
        type="option"
        icon={ICONS.metadata.secondary}
        text="Filter by this field"
      />
    )}
    content={({ toggleModal }): React.ReactNode => (
      <FilterPostReportBooleanForm
        addPostFilter={addPostFilter}
        path={path}
        field={field}
        defaultValues={defaultValues}
        onDone={toggleModal}
      />
    )}
    {...rest}
  />
);
